module.exports = __webpack_public_path__ + "static/img/gpt24.841a5384.png";